module.exports = __webpack_public_path__ + "static/media/customer-icon-inactive.c52a2cc5.svg";